export default __webpack_public_path__ + "static/media/totoev_company_logo_square.cfdcda69.png";